 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/Cover'
 import TEXTBACK_COVER_TEXT from '@/components/text/Back_Cover_Text'
 import TEXTTITLE_PAGE from '@/components/text/Title_Page'
 import TEXTCONTENTS from '@/components/text/Contents'
 import TEXTPART_ONE from '@/components/text/Part_One'
 import TEXTCHAPTER_ONE from '@/components/text/Chapter_One'
 import TEXTCHAPTER_TWO from '@/components/text/Chapter_Two'
 import TEXTCHAPTER_THREE from '@/components/text/Chapter_Three'
 import TEXTCHAPTER_FOUR from '@/components/text/Chapter_Four'
 import TEXTCHAPTER_FIVE from '@/components/text/Chapter_Five'
 import TEXTCHAPTER_SIX from '@/components/text/Chapter_Six'
 import TEXTCHAPTER_SEVEN from '@/components/text/Chapter_Seven'
 import TEXTCHAPTER_EIGHT from '@/components/text/Chapter_Eight'
 import TEXTCHAPTER_NINE from '@/components/text/Chapter_Nine'
 import TEXTPART_TWO from '@/components/text/Part_Two'
 import TEXTCHAPTER_TEN from '@/components/text/Chapter_Ten'
 import TEXTCHAPTER_ELEVEN from '@/components/text/Chapter_Eleven'
 import TEXTCHAPTER_TWELVE from '@/components/text/Chapter_Twelve'
 import TEXTCHAPTER_THIRTEEN from '@/components/text/Chapter_Thirteen'
 import TEXTCHAPTER_FOURTEEN from '@/components/text/Chapter_Fourteen'
 import TEXTCHAPTER_FIFTEEN from '@/components/text/Chapter_Fifteen'
 import TEXTCHAPTER_SIXTEEN from '@/components/text/Chapter_Sixteen'
 import TEXTCHAPTER_SEVENTEEN from '@/components/text/Chapter_Seventeen'
 import TEXTCHAPTER_EIGHTEEN from '@/components/text/Chapter_Eighteen'
 import TEXTCHAPTER_NINETEEN from '@/components/text/Chapter_Nineteen'
 import TEXTCHAPTER_TWENTY from '@/components/text/Chapter_Twenty'
 import TEXTCHAPTER_TWENTYONE from '@/components/text/Chapter_Twenty-One'
 import TEXTPART_THREE from '@/components/text/Part_Three'
 import TEXTCHAPTER_TWENTYTWO from '@/components/text/Chapter_Twenty-Two'
 import TEXTCHAPTER_TWENTYTHREE from '@/components/text/Chapter_Twenty-Three'
 import TEXTCHAPTER_TWENTYFOUR from '@/components/text/Chapter_Twenty-Four'
 import TEXTCHAPTER_TWENTYFIVE from '@/components/text/Chapter_Twenty-Five'
 import TEXTCHAPTER_TWENTYSIX from '@/components/text/Chapter_Twenty-Six'
 import TEXTCHAPTER_TWENTYSEVEN from '@/components/text/Chapter_Twenty-Seven'
 import TEXTCHAPTER_TWENTYEIGHT from '@/components/text/Chapter_Twenty-Eight'
 import TEXTCHAPTER_TWENTYNINE from '@/components/text/Chapter_Twenty-Nine'
 import TEXTCHAPTER_THIRTY from '@/components/text/Chapter_Thirty'
 import TEXTCHAPTER_THIRTYONE from '@/components/text/Chapter_Thirty-One'
 import TEXTACKNOWLEDGMENTS from '@/components/text/Acknowledgments'
 import TEXTREADERS_GUIDE from '@/components/text/Readers_Guide'
 import TEXTQUESTIONS_FOR_DISCUSSION from '@/components/text/Questions_for_Discussion'
 import TEXTA_CONVERSATION_WITH_THE_AUTHOR from '@/components/text/A_Conversation_with_the_Author'
 import TEXTBPA from '@/components/text/BPA'
 import TEXTEXCERPT from '@/components/text/Excerpt'
 import TEXTEXCERPT1 from '@/components/text/Excerpt1'
 import TEXTEXCERPT2 from '@/components/text/Excerpt2'
 import TEXTCOPYRIGHT from '@/components/text/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/Contents",
 			"name" : "text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/text/Part_One",
 			"name" : "text/Part_One",
 			"component" : TEXTPART_ONE
 		},
 		{
 			"path" : "/text/Chapter_One",
 			"name" : "text/Chapter_One",
 			"component" : TEXTCHAPTER_ONE
 		},
 		{
 			"path" : "/text/Chapter_Two",
 			"name" : "text/Chapter_Two",
 			"component" : TEXTCHAPTER_TWO
 		},
 		{
 			"path" : "/text/Chapter_Three",
 			"name" : "text/Chapter_Three",
 			"component" : TEXTCHAPTER_THREE
 		},
 		{
 			"path" : "/text/Chapter_Four",
 			"name" : "text/Chapter_Four",
 			"component" : TEXTCHAPTER_FOUR
 		},
 		{
 			"path" : "/text/Chapter_Five",
 			"name" : "text/Chapter_Five",
 			"component" : TEXTCHAPTER_FIVE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js